<template>
  <DxPopup
    :visible.sync="localPopupVisible"
    :width="600"
    :height="'auto'"
    :showTitle="true"
    title="Import Journal"
    :dragEnabled="true"
    :closeOnOutsideClick="false"
    :wrapperAttr="{ class: 'gc-popup-uploader' }"
  >
    <div class="upload-content">
      <div class="drop-zone">
        <DxFileUploader
          :multiple="false"
          :upload-mode="'useForm'"
          @value-changed="onFileUploaded"
          :allowedFileExtensions="['.xls', '.xlsx']"
          :accept="'.xls,.xlsx'"
          drop-zone=".drop-zone"
          :selectButtonText="'Browse'"
          :labelText="'Browse or Drag File Here'"
          :ref="'gc-uploader'"
        />
      </div>

      <div class="footer">
        <DxButton
          text="Import"
          type="success"
          :disabled="disableImport"
          @click="importFile"
        />
        <DxButton text="Cancel" @click="onPopupHiding" />
      </div>
    </div>
  </DxPopup>
</template>

<script>
import { DxPopup } from "devextreme-vue";
import { DxFileUploader } from "devextreme-vue/file-uploader";

import * as XLSX from "xlsx"; // Import the xlsx library

export default {
  components: {
    DxPopup,
    DxFileUploader,
  },
  props: {
    popupVisible: {
      type: Boolean,
    },
    returnImportFile: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      localPopupVisible: this.popupVisible,
      disableImport: true,
      fileData: [],
    };
  },
  watch: {
    popupVisible(val) {
      this.localPopupVisible = val;
    },
  },
  methods: {
    onPopupHiding() {
      this.disableImport = true;
      this.localPopupVisible = false;
      this.$emit("update:popupVisible", false);

      let uploader = this.$refs["gc-uploader"].instance;
      if (uploader) {
        uploader.reset();
        this.fileData = [];
      }
    },
    onFileUploaded(e) {
      const file = e.value[0]; // Get the first file in case multiple files are allowed

      const errorMsg = document.getElementsByClassName(
        "dx-fileuploader-file-status-message"
      );
      if (errorMsg.length > 0 && file) {
        if (errorMsg[0].textContent === "Ready to upload") {
          const reader = new FileReader();
          reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const sheetData = XLSX.utils.sheet_to_json(sheet); // Converts to JSON
            this.fileData = sheetData;

            this.disableImport = false;
          };
          reader.readAsArrayBuffer(file); // Use ArrayBuffer for binary files
        } else {
          this.disableImport = true;
        }
      }
    },
    importFile() {
      this.returnImportFile(this.fileData);
      this.onPopupHiding();
    },
  },
};
</script>
<style lang="scss">
.gc-popup-uploader {
  .upload-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .dx-fileuploader-input-label {
    opacity: 0.5;
  }
  .dx-widget.dx-fileuploader {
    width: 100%;
  }
  .dx-fileuploader-button.dx-button {
    position: unset;
    width: 140px;
    height: 100%;
    background-color: #03a9f4;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;

    .dx-button-content {
      padding: 8px 16px;
    }

    .dx-button-text {
      color: white;
    }
  }

  .dx-fileuploader-button {
    .dx-button-content::after {
      content: unset;
    }
  }

  .dx-fileuploader-input-wrapper {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    justify-content: space-between;

    .dx-fileuploader-input-container {
      //   width: unset;
      background-color: #f3f4f6;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
  }

  .dx-fileuploader-content {
    // background-color: #0000001f;
    // padding: 10px;
    // border-radius: 10px;
    height: "auto";
    display: block;
    .dx-fileuploader-input-wrapper {
      padding: unset;
      border: unset;
    }
  }
  .dx-fileuploader-input-wrapper::after,
  .dx-fileuploader-input-wrapper::before {
    content: unset;
  }

  .footer {
    > div.dx-widget.dx-button:first-child {
      margin-right: 20px;
    }

    > div.dx-widget.dx-button:last-child {
      border: 1px solid red;

      .dx-button-text {
        color: red;
      }
    }
  }
}
</style>
